<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <div class="mp-form text-center">
    <h5 class="mb-3">{{ t('registration.successTitle') }}</h5>
    <p class="text-muted mb-4">{{ t('registration.successDesc') }}</p>
    <router-link :to="{ name: 'login' }" class="btn mp-btn-primary w-100">
      {{ t('registration.backToLogin') }}
    </router-link>
  </div>
</template>
